module.exports = __webpack_public_path__ + "static/img/8.2498972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/culturalCourses/8.png
// module id = ofb8
// module chunks = 0